export const KAIZENCONFIG = {
    LOOKUPKAIZENSTATUSCONFIG:
        [
            'Pending Approval',
            'In Progress',
            'Completed',
            'Rejected'
        ],
    LOOKUPAPPROVALSTATUSCONFIG:
        [
            'Approved',
            'On Hold',
            'Rejected'
        ],
    KAIZEN_AREA_GRID: {

        showBorders: true,
        rowAlternationEnabled: true,
        allowColumnReordering: true,
        allowColumnResizing: true,
        columnResizingMode: "widget",
        columnAutoWidth: true,
        columnChooser: {
            enabled: true,
            allowSearch: true,
            mode: "select"
        },

        headerFilter: {
            visible: true
        },
        sorting: {
            mode: "multiple"
        },
        grouping: {
            contextMenuEnabled: true
        },
        searchPanel: {
            visible: true
        },
        scrolling: { showScrollbar: "always" },
        filterRow: {
            visible: true,
            applyFilter: "auto"
        },
        paging: {
            pageSize: 5
        },
        pager: {
            showPageSizeSelector: false,
            allowedPageSizes: [5, 10, 20, 50],
            showInfo: true
        },
        export: {
            enabled: true,
            fileName: "Actions"
        },
        editing: {
            mode: 'batch',
            allowUpdating: false,
            allowAdding: false,
            allowDeleting: false,
            useIcons: true
        },
        /*
        onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
        onToolbarPreparing: function (e) {
            var dataGrid = e.component;
            var toolbarItems = e.toolbarOptions.items;
            // Adds a new item
            toolbarItems.unshift({
                location: "before",
                template: "Area"
            }, {
                location: "after",
                widget: "dxButton",
                options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                        dataGrid.refresh();
                    }
                }
            });
        }
    },

    KAIZEN_AREA_COL: [
        {
            dataField: "id",
            caption: "ID",
            dataType: "number",
            width: 50,
            visible: false,
            allowEditing: false
        },
        {
            dataField: "siteCode",
            caption: "Site Code",
            width: 50,
            visible: false,
            allowEditing: false
        },
        {
            dataField: "areaName",
            caption: "Area Name",
            validationRules: [{
                type: "required",
                message: "Area Name is required"
            }]
        },
        {
            dataField: "cellName",
            caption: "Cell Name",
            validationRules: [{
                type: "required",
                message: "Cell Name is required"
            }]
        },
        {
            dataField: "active",
            caption: "Active",
            lookup: {
                dataSource: ["Y", "N"]
            },
            validationRules: [{
                type: "required",
                message: "Active is required"
            }]
        }
    ],
    KAIZEN_CELL_GRID: {

        showBorders: true,
        rowAlternationEnabled: true,
        allowColumnReordering: true,
        allowColumnResizing: true,
        columnResizingMode: "widget",
        columnAutoWidth: true,
        columnChooser: {
            enabled: true,
            allowSearch: true,
            mode: "select"
        },

        headerFilter: {
            visible: true
        },
        sorting: {
            mode: "multiple"
        },
        grouping: {
            contextMenuEnabled: true
        },
        searchPanel: {
            visible: true
        },
        scrolling: { showScrollbar: "always" },
        filterRow: {
            visible: true,
            applyFilter: "auto"
        },
        paging: {
            pageSize: 5
        },
        pager: {
            showPageSizeSelector: false,
            allowedPageSizes: [5, 10, 20, 50],
            showInfo: true
        },
        export: {
            enabled: true,
            fileName: "Actions"
        },
        editing: {
            mode: 'batch',
            allowUpdating: true,
            allowAdding: true,
            allowDeleting: true,
            useIcons: true
        },
        /*
        onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
        onToolbarPreparing: function (e) {
            var dataGrid = e.component;
            var toolbarItems = e.toolbarOptions.items;
            // Adds a new item
            toolbarItems.unshift({
                location: "before",
                template: "Cell"
            }, {
                location: "after",
                widget: "dxButton",
                options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                        dataGrid.refresh();
                    }
                }
            });
        }
    },

    KAIZEN_CELL_COL: [
        {
            dataField: "id",
            caption: "ID",
            dataType: "number",
            width: 50,
            visible: false,
            allowEditing: false
        },
        {
            dataField: "siteCode",
            caption: "Site Code",
            width: 50,
            visible: false,
            allowEditing: false
        },
        {
            dataField: "cellName",
            caption: "Cell Name",
            validationRules: [{
                type: "required",
                message: "Cell name is required"
            }]
        }, {
            dataField: "areaName",
            caption: "Area Name",
            lookup: {
                dataSource: []
            },
            validationRules: [{
                type: "required",
                message: "Area Name is required"
            }]
        },
        {
            dataField: "active",
            caption: "Active",
            lookup: {
                dataSource: ["Y", "N"]
            },
            validationRules: [{
                type: "required",
                message: "Active is required"
            }]
        }
    ],

    KAIZEN_LINE_GRID: {

        showBorders: true,
        rowAlternationEnabled: true,
        allowColumnReordering: true,
        allowColumnResizing: true,
        columnResizingMode: "widget",
        columnAutoWidth: true,
        columnChooser: {
            enabled: true,
            allowSearch: true,
            mode: "select"
        },

        headerFilter: {
            visible: true
        },
        sorting: {
            mode: "multiple"
        },
        grouping: {
            contextMenuEnabled: true
        },
        searchPanel: {
            visible: true
        },
        scrolling: { showScrollbar: "always" },
        filterRow: {
            visible: true,
            applyFilter: "auto"
        },
        paging: {
            pageSize: 5
        },
        pager: {
            showPageSizeSelector: false,
            allowedPageSizes: [5, 10, 20, 50],
            showInfo: true
        },
        export: {
            enabled: true,
            fileName: "Actions"
        },
        editing: {
            mode: 'batch',
            allowUpdating: true,
            allowAdding: true,
            allowDeleting: true,
            useIcons: true
        },
        /*
        onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
        onToolbarPreparing: function (e) {
            var dataGrid = e.component;
            var toolbarItems = e.toolbarOptions.items;
            // Adds a new item
            toolbarItems.unshift({
                location: "before",
                template: "Line"
            }, {
                location: "after",
                widget: "dxButton",
                options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                        dataGrid.refresh();
                    }
                }
            });
        }
    },

    KAIZEN_LINE_COL: [
        {
            dataField: "id",
            caption: "ID",
            dataType: "number",
            width: 50,
            visible: false,
            allowEditing: false
        },
        {
            dataField: "siteCode",
            caption: "Site Code",
            width: 50,
            visible: false,
            allowEditing: false
        },
        {
            dataField: "lineName",
            caption: "Line Name",
            validationRules: [{
                type: "required",
                message: "Line name is required"
            }]
        },
        {
            dataField: "cellName",
            caption: "Cell Name",
            lookup: {
                dataSource: [],
            },
            validationRules: [{
                type: "required",
                message: "Cell name is required"
            }]
        }, {
            dataField: "areaName",
            caption: "Area Name",
            lookup: {
                dataSource: [],
            },
            validationRules: [{
                type: "required",
                message: "Area Name is required"
            }]
        },
        {
            dataField: "active",
            caption: "Active",
            lookup: {
                dataSource: ["Y", "N"]
            },
            validationRules: [{
                type: "required",
                message: "Active is required"
            }]
        }
    ]

}